import { FeatureFlagsConfig } from './entities';

export const sessionRecorderExperimentName = 'session_recorder_redistributor';

export const phoneNumberOptInFeature = 'phone_number_opt_in';

export const fbAutologinSimpleRegExperimentName = 'fb_autologin_simple_reg';

export const simpleRegSummaryScreenExperimentName = 'summary_section_simple_reg';

export const exCreativeFeatureName = 'ex_creative_sr_and_ec';

export const SimpleRegChatOnFunnel2ExperimentName = 'simple_reg_chat_on_funnel_2';

export const funnelRequestBuilderExperimentName = 'request_builder_funnel_1';

export const requireEmailConsentFeature = 'require_email_consent';

export const expertsParamsFeature = 'experts_params';

export const activationQuestExperimentName = 'activation_quest';

export const aiFunnelExperimentName = 'ai_funnel_mvp';

export const consentSettingsAvailableAsknebulaFeatureName = 'consent_settings_available_asknebula';

export const impressumAvailableAsknebulaFeatureName = 'impressum_available_asknebula';

export const expertsParamsDefaultValue: {
  sort: string;
  filter?: Record<string, string>;
} = {
  sort: 'status_active_livechats_rand',
};

export enum SessionRecorderExperimentGroups {
  RECORD_ON = 'record_on',
  RECORD_OFF = 'record_off',
}

export enum FbAutologinSimpleRegExperimentGroups {
  CONTROL = 'as-is',
  FB_AUTOLOGIN = 'fb_autologin',
}

export enum SimpleRegSummaryScreenExperimentGroups {
  CONTROL = 'control',
  EXPERT_FOCUS = 'test_expert_focus',
  USER_FOCUS = 'test_user_focus',
}

export enum AiFunnelExperimentGroups {
  CONTROL = 'control',
  TEST_1 = 'test_1',
}

export enum SimpleRegChatOnFunnel2ExperimentGroups {
  CONTROL = 'simple_reg_as-is',
  EXPERTS = 'simple_reg_experts',
  ONLY_MESSAGE = 'simple_reg_only_message',
}

export const featureFlagsConfig: FeatureFlagsConfig = {
  features: {
    [sessionRecorderExperimentName]: {
      defaultValue: SessionRecorderExperimentGroups.RECORD_OFF,
      rules: [
        {
          variations: [SessionRecorderExperimentGroups.RECORD_OFF, SessionRecorderExperimentGroups.RECORD_ON],
          weights: [0.8, 0.2],
        },
      ],
      shouldNotTrack: true,
    },
    [fbAutologinSimpleRegExperimentName]: {
      defaultValue: FbAutologinSimpleRegExperimentGroups.CONTROL,
    },
    [phoneNumberOptInFeature]: {
      defaultValue: null,
    },
    [requireEmailConsentFeature]: {
      defaultValue: true,
    },
    [simpleRegSummaryScreenExperimentName]: {
      defaultValue: SimpleRegSummaryScreenExperimentGroups.CONTROL,
    },
    [SimpleRegChatOnFunnel2ExperimentName]: {
      defaultValue: SimpleRegChatOnFunnel2ExperimentGroups.CONTROL,
    },
    [exCreativeFeatureName]: {
      defaultValue: false,
    },
    [aiFunnelExperimentName]: {
      defaultValue: AiFunnelExperimentGroups.CONTROL,
    },
    [expertsParamsFeature]: {
      defaultValue: expertsParamsDefaultValue,
    },
    [consentSettingsAvailableAsknebulaFeatureName]: {
      defaultValue: true,
    },
    [impressumAvailableAsknebulaFeatureName]: {
      defaultValue: false,
    },
  },
};
